let sessionEpoch = 0;
let sessionInvalidated = false;

export class SessionExpiredFlowError extends Error {
  readonly code = "ERR_SESSION_EXPIRED";

  constructor() {
    super("The authenticated session has expired");
    this.name = "SessionExpiredFlowError";
  }
}

export const getSessionEpoch = (): number => sessionEpoch;

export const isCurrentSessionEpoch = (epoch: number): boolean =>
  epoch === sessionEpoch;

export const isSessionInvalidated = (): boolean => sessionInvalidated;

export const invalidateSession = (): boolean => {
  if (sessionInvalidated) {
    return false;
  }

  sessionInvalidated = true;
  sessionEpoch += 1;
  return true;
};

export const resumeSession = (): void => {
  sessionInvalidated = false;
};
